import { createShadowRoot, html } from "../lib";

const template = document.createElement("template");

template.innerHTML = html`
  <style>
    .wrapper {
      color: hsl(60 100 22);
      background-color: hsl(60 100 97);
      border-color: hsl(60 100 22);
      border-radius: 5px;
      border-style: solid;
      border-width: 1px;
      padding: 10px;
    }
  </style>

  <div class="wrapper"></div>
`;

class El extends HTMLElement {
  #container;

  constructor() {
    super();

    const { querySelector } = createShadowRoot(this, template);

    this.#container = querySelector("div");
  }

  set content(content) {
    this.#container.replaceChildren(content);
  }
}

customElements.define("o-warning", El);

export const createWarning = message => {
  const el = new El();

  el.content = message;

  return el;
};
